import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  automatchingStartDelayMinutes: number | null;
  showHelperText?: boolean;
};

const ToggleAutomatching = ({
  checked,
  onChange,
  automatchingStartDelayMinutes,
  showHelperText = true,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column">
      {showHelperText ? (
        <Typography fontWeight={600}>
          {t("order:automatchingHelperText", {
            minutes: automatchingStartDelayMinutes,
          })}
        </Typography>
      ) : null}
      <Box>
        <FormControlLabel
          onChange={(_, checked) => onChange(!checked)}
          checked={checked}
          control={<Checkbox />}
          label={t("order:automatchingLabel")}
        />
      </Box>
    </Box>
  );
};

export default ToggleAutomatching;
